export default [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "vnd.ms-excel",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "vnd.openxmlformats-officedocument.wordprocessingml.document",
    "vnd.openxmlformats-officedocument.presentationml.presentation",
    "msword",
    "doc",
    "docx",
    "pdf",
    "ppt",
    "pptx",
    "xlsx",
    "xls",
    "txt",
    "plain",
    "ai",
    "js",
    "javascript",
    "json",
    "css",
    "csv",
    "eps",
    "exe",
    "html",
    "mov",
    "mp3",
    "mp4",
    "php",
    "psd",
    "rar",
    "svg",
    "wav",
    "zip",
    "mpeg",
    "vnd.ms-powerpoint",
    "svg+xml",
    "x-zip-compressed",
];